$(function() {

	const hasReCaptcha = $("#recaptcha-key").length;

	// reCaptcha
	$("#reset-form").on("submit", event => {
		const tokenInput = $("#recaptcha-token");

		if(tokenInput.val() === "" && hasReCaptcha) {
			event.preventDefault();
			grecaptcha.ready(function() {
				grecaptcha.execute($("#recaptcha-key").val(), {action: 'password_reset'}).then(function(token) {
					tokenInput.val(token);
					$("#reset-form-submit").click();
				});
			});
		}
	});
});
